<template>
  <main class="project" v-if="Object.keys(page).length !== 0" :key="uid">
    <div class="roller"></div>
    <section>
      <div class="title flex">
        <span class="inner-title">
            <router-link
            :to="{ name: 'artist', params: { uid: page.artistuid } }"
            >{{ page.artist }}</router-link
          >
        </span>
        <div class="extramenu">
          <div class="submenu">
            <p>{{ page.title }}</p>
            <p v-if="length > 0">
              {{ counter }}
            </p>
            <router-link
            :to="{ name: 'artist', params: { uid: page.artistuid, filter: page.category[0] } }"
            >Artist Overview</router-link
          >
          </div>
        </div>
      </div>
    </section>
    <div v-if="page.videos.length > 0" class="project-gallery">
      <slide
        ref="slide"
        :class="{ active: 0 == slideIndex }"
        :file="page.videos[0]"
      ></slide>
    </div>
    <div v-else class="project-gallery" @click="changeSlide()">
      <slide
        ref="slide"
        v-for="(file, index) in files"
        :key="index"
        :class="{ active: index == slideIndex }"
        :file="file"
      ></slide>
      <div v-if="length > 0" class="prev"></div>
      <div v-if="length > 0" class="next"></div>
    </div>
    <div class="project-footer">
      &nbsp;
    </div>
  </main>
  <main v-else>
    <section>
      <div class="roller"></div>
      <div class="title loading">
        Loading
      </div>
    </section>
  </main>
</template>

<script>
const Slide = () => import(/* webpackChunkName: "Slide" */ "@/components/Slide");

export default {
  name: "project",
  metaInfo() {
    return {
      title: this.page ? "– " + this.page.title : ''
    };
  },
  components: {
    Slide
  },
  props: {
    uid: String,
    project: String,
    num: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.$store.dispatch("loadProject", {
      artist: this.uid,
      project: this.project
    }).then(() => {
        this.$root.$emit('projectType', this.page.projecttype);
    });
  },
  data() {
    return {
      slideIndex: 0
    };
  },
  computed: {
    page() {
      return this.$store.state.project;
    },
    files() {
      return this.check(this.page.images);
    },
    length() {
      return this.files.length - 1;
    },
    counter() {
      return this.slideIndex + 1 + "/" + (this.length + 1);
    }
  },
    mounted() {
        this.slideIndex = this.num;
        window.addEventListener('keyup', (e) => {
        if (e.keyCode == 39) {
            this.keyChangeSlide('next')
        }
        if (e.keyCode == 37) {
            this.keyChangeSlide('prev')
        }
        });
  },
  methods: {
    check(array) {
      var noGif = array.filter(file => {
        return file.extension != "gif";
      });
      return noGif;
    },
    changeSlide() {
      let target = event.target;
      if (target.tagName === "DIV") {
        if (target.classList.contains("prev")) {
          if (this.slideIndex === 0) {
            this.slideIndex = this.length;
          } else {
            this.slideIndex--;
          }
        } else {
          if (this.slideIndex === this.length) {
            this.slideIndex = 0;
          } else {
            this.slideIndex++;
          }
        }
      }
    },
    keyChangeSlide(dir) {
      if (dir == 'prev') {
        if (this.slideIndex === 0) {
          this.slideIndex = this.length;
        } else {
          this.slideIndex--;
        }
      } else {
        if (this.slideIndex === this.length) {
          this.slideIndex = 0;
        } else {
          this.slideIndex++;
        }
      } 
    }
  }
};
</script>

<style lang="scss">
.inner-title {
  position: relative;
  padding-bottom: 0.25rem !important;
  @media only screen and (max-width: 768px) {
    flex: 0 0 100% !important;
  }
}
.extramenu {
  display: flex;
}
.submenu {
  font-family: "Kolektiv-Light", Times, serif;
  font-size: var(--fs);
  line-height: var(--lh);
  text-transform: none;
  letter-spacing: normal;
  padding: 0 1.5rem 1.5rem 0;
  @media only screen and (max-width: 768px) {
    width: 80vw;
  }
}
.project {
  height: 100%;
  display: flex;
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  flex-direction: column;
  .project-gallery {
    flex: 1 0 auto;
    width: 100%;
    padding: 1.5rem 1.5rem 0;
    position: relative;
    .next,
    .prev {
      width: 50%;
      height: 100%;
      position: absolute;
      top: 0;
      @media only screen and (max-width: 800px) {
        width: 50%;
        z-index: 9;
      }
      cursor: pointer;
      &:before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0;
        font-family: "SORepresent-Light", Times, serif;
        font-size: calc(4 * var(--fs));
        text-transform: uppercase;
        letter-spacing: -0.05em;
        line-height: 1;
        transition: opacity 0.5s ease;
      }
      &:hover {
        &:before {
          opacity: 1;
        }
      }
    }
    .next {
      right: 0;
      &:before {
        content: "\2192";
        right: 1.5rem;
        @media only screen and (max-width: 800px) {
          content: "";
        }
      }
    }
    .prev {
      left: 0;
      &:before {
        content: "\2190";
        left: 1.5rem;
        @media only screen and (max-width: 800px) {
          content: "";
        }
      }
    }
  }
  .project-footer {
    padding: 1.5rem;
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
  }
}
</style>
